
import React, { Fragment } from 'react';
import MainNavigation from '../MainNavigation';
import MainFooter from '../MainFooter';
import classes from './contact.module.css';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaHospital } from 'react-icons/fa';

const Contacts = () => {
    return (
        <Fragment>
            <MainNavigation />
            <div className={classes.container}>
                <header className={classes.heroSection}>
                    <h1>Contact Us</h1>
                    <p>We're here to help you manage your hospital better. Get in touch with our experts today.</p>
                </header>

                <main className={classes.contentWrapper}>
                    <div className={classes.contactCard}>
                        <h2>Get in Touch</h2>

                        <div className={classes.infoItem}>
                            <div className={classes.iconBox}>
                                <FaHospital />
                            </div>
                            <div className={classes.infoText}>
                                <h4>Company Name</h4>
                                <p>Invensoft Solutions</p>
                            </div>
                        </div>

                        <div className={classes.infoItem}>
                            <div className={classes.iconBox}>
                                <FaMapMarkerAlt />
                            </div>
                            <div className={classes.infoText}>
                                <h4>Our Office</h4>
                                <p>13-A, Karanbharti society, katraj 411046</p>
                            </div>
                        </div>

                        <div className={classes.infoItem}>
                            <div className={classes.iconBox}>
                                <FaPhoneAlt />
                            </div>
                            <div className={classes.infoText}>
                                <h4>Call Support</h4>
                                <p>+91 75593 83489</p>
                            </div>
                        </div>

                        <div className={classes.infoItem}>
                            <div className={classes.iconBox}>
                                <FaEnvelope />
                            </div>
                            <div className={classes.infoText}>
                                <h4>Email Us</h4>
                                <p>ajay.nigade19@gmail.com</p>
                            </div>
                        </div>

                        <div className={classes.infoItem}>
                            <div className={classes.iconBox}>
                                <FaHospital size={20} />
                            </div>
                            <div className={classes.infoText}>
                                <h4>Website</h4>
                                <p><a href="https://invensoftsolutions.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>invensoftsolutions.com</a></p>
                            </div>
                        </div>

                        <div className={classes.socialActions}>
                            <a href="https://wa.me/917559383489" target="_blank" rel="noopener noreferrer" className={`${classes.actionButton} ${classes.whatsapp}`}>
                                <FaWhatsapp size={22} /> Chat on WhatsApp
                            </a>
                            <a href="mailto:ajay.nigade19@gmail.com" className={`${classes.actionButton} ${classes.email}`}>
                                <FaEnvelope size={22} /> Send an Email
                            </a>
                        </div>
                    </div>

                    <div className={classes.mapCard}>
                        {/* Placeholder for Map or additional info */}
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.541641467165!2d73.85268907416787!3d18.459109071050808!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2eb7f8fc2620b%3A0xe19fdd54ce5aa78a!2sKaran%20Bharti%20apartment!5e0!3m2!1sen!2sin!4v1775382400643!5m2!1sen!2sin"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Office Location"
                        ></iframe>
                    </div>
                </main>
            </div>
            <MainFooter />
        </Fragment>
    );
}

export default Contacts;